export const initialState = {
  settlements: [],
  page: {},
  links: {},
  loadingSettlements: false,
  error: {},
  errorAlert: {},
  createSettlement: {
    sponsorSelectionComplete: false,
    addAuthorizationsComplete: false,
    createSettlementResult: "",
    settlementId: {},
    sponsorSlug: null,
    dates: {
      from: "",
      to: ""
    },
    includedClaims: [],
    excludedClaims: [],
    actualStep: 1,
    errorMessage: '',
    uploadedFiles: false,
    coverages: []
  },
  settlementSelected: {},
  settlementSummary: {},
  settlementDetail: [],
  authorizations: [],
  settlementDocuments: [],
  manualAuthorizations: {
    requireManualAuthorizations: false,
    quantity: '',
    amount: '' 
  }
}

export default {
  ...initialState
}